import { Controller } from "@hotwired/stimulus"

// Живий підрахунок споживання при введенні показника (спільний для масового
// вводу А5 і одиночної форми А4): (нове − попереднє) × коефіцієнт. Порожнє,
// нечислове, від'ємне або перший показник → «—». Без JS сторінка робоча —
// споживання рахує сервер.
export default class extends Controller {
  // Перерахунок клітинки/рядка споживання для поля, що змінилось.
  calculate(event) {
    const input = event.target
    const scope = input.closest("[data-readings-row]") || this.element
    const output = scope.querySelector("[data-readings-consumption]")
    if (!output) return

    const prevRaw = input.dataset.readingsPreviousValue
    const hasPrevious = prevRaw !== undefined && prevRaw !== ""
    const coefficient = this.parse(input.dataset.readingsCoefficient) ?? 1
    const value = this.parse(input.value)
    // Попередній показник теж у форматі застосунку («123 846,8» з комою), тож
    // розбираємо його тим самим parse(), а не parseFloat (той обрізав би на комі).
    const previous = hasPrevious ? this.parse(prevRaw) : null

    if (previous === null || value === null) {
      this.render(output, null)
      return
    }

    const consumption = (value - previous) * coefficient
    this.render(output, consumption < 0 ? null : consumption)
  }

  // Зміна дати зняття (А5): очищаємо лише передзаповнені поля, щоб внесене за
  // стару дату не задублювалось на нову; ручний ввід лишаємо.
  dateChanged() {
    this.element
      .querySelectorAll('[data-readings-prefilled="true"]')
      .forEach((input) => {
        input.value = ""
        input.dataset.readingsPrefilled = "false"
        input.dispatchEvent(new Event("input", { bubbles: false }))
      })
  }

  render(output, consumption) {
    if (consumption === null) {
      output.textContent = "—"
      return
    }
    const unit = output.dataset.readingsUnit
    const suffix = output.dataset.readingsSuffix
    let text = this.format(consumption)
    if (unit) text += ` ${unit}`
    if (suffix) text += ` ${suffix}`
    output.textContent = text
  }

  // Кома/крапка/пробіли (в т.ч. NBSP) — як у форматі чисел застосунку.
  parse(raw) {
    if (raw === undefined || raw === null) return null
    const cleaned = String(raw).replace(/[\s ]/g, "").replace(",", ".")
    if (cleaned === "") return null
    const number = Number(cleaned)
    return Number.isNaN(number) ? null : number
  }

  // «123 846,8», «0,015»: до 3 знаків, без незначущих нулів, NBSP тисяч.
  format(number) {
    const rounded = Math.round(number * 1000) / 1000
    let [integer, fraction = ""] = rounded.toFixed(3).split(".")
    fraction = fraction.replace(/0+$/, "")
    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    return fraction ? `${integer},${fraction}` : integer
  }
}
